module.exports = __webpack_public_path__ + "static/img/zhekou.5356a16f.png";